import _regeneratorRuntime from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import { walletConnect, checkMetamask, okxwalletConnect, checkOkxwallet, switchChain } from '@/utils/connect.js';
export default {
  name: 'UnsupportedChain',
  props: {
    drawerShow: {
      modelValue: Boolean
    },
    chainid: {
      modelValue: Number
    }
  },
  data: function data() {
    return {
      popBoxShow: false
    };
  },
  watch: {
    drawerShow: {
      handler: function handler(to, from) {
        this.popBoxShow = this.drawerShow;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    isMobile: function isMobile() {
      return this.$store.state.isMobile;
    }
  },
  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {},
  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.chainid) {
                _context.next = 7;
                break;
              }
              _this.handleClosesBox();
              _context.next = 4;
              return switchChain(_this.chainid, 1);
            case 4:
              _this.$store.commit('setShowConnectCallBack1', true);
              _context.next = 8;
              break;
            case 7:
              _this.$emit('clickSwitch');
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleClosesBox: function handleClosesBox() {
      this.$emit('handleClosesBox');
    }
  }
};